export default __webpack_public_path__ + "static/chemise.inspirations-8b183197330eb959cf46587da19dee72.jpg";